import { MigrationSpec } from "../migration.models"

const metaAdsFlowBlockTemplates: MigrationSpec = {
  type: "SEED_META_ADS_FLOW_BLOCK_TEMPLATES",
  collection: "FlowBlockTemplate",
  risk: "SAFE",
  title: {
    en: "Meta Ads → FlowBot block templates and triggers",
    tr: "Meta Ads → FlowBot blok şablonları ve tetikleyiciler"
  },
  description: {
    en:
      "Inserts, when missing and keyed by `type` + `category`, the Meta conversion event block " +
      "(`meta_conversion_event`) and three triggers (`category: trigger`): conversation started " +
      "from an ad (`conversation_from_ad`), conversation closed (`conversation_closed`) and tag " +
      "added to conversation (`conversation_tag_added`). Written with `$setOnInsert`, so a second " +
      "run changes nothing and existing (possibly edited) templates are never overwritten.",
    tr:
      "Yoksa, `type` + `category` anahtarıyla Meta conversion event bloğunu " +
      "(`meta_conversion_event`) ve üç tetikleyiciyi (`category: trigger`) ekler: reklamdan " +
      "başlayan konuşma (`conversation_from_ad`), konuşma kapandı (`conversation_closed`) ve " +
      "konuşmaya etiket eklendi (`conversation_tag_added`). `$setOnInsert` ile yazılır: ikinci " +
      "çalıştırma hiçbir şey değiştirmez, mevcut (düzenlenmiş olabilecek) şablonların üzerine " +
      "asla yazılmaz."
  },
  expectedDocuments: {
    filter: {
      $or: [
        { type: "meta_conversion_event", category: "meta_conversion_event" },
        { type: "conversation_from_ad", category: "trigger" },
        { type: "conversation_closed", category: "trigger" },
        { type: "conversation_tag_added", category: "trigger" }
      ]
    },
    count: 4
  },
  notes: [
    {
      en:
        "Until this runs, these three triggers do not appear in the flow builder — the builder " +
        "only offers a trigger whose block template exists.",
      tr:
        "Bu çalışana kadar bu üç tetikleyici flow builder'da görünmez — builder yalnızca blok " +
        "şablonu olan tetikleyiciyi sunar."
    }
  ]
}

export default metaAdsFlowBlockTemplates
